<template>
  <div class="suteng">
    <div class="title">
      <b>{{$t("case.huarong.name")}}</b>
      <span>【{{$t("case.huarong.business")}}】</span>
    </div>
    <div class="business">
      <h4>{{$t("case.haoen.title")}}</h4>
      <div class="box">
       {{$t("case.huarong.details")}}
        <div>
         {{$t("case.huarong.details2")}}
        </div>
      </div>
      <div class="content">
        <div class="content-img">
          <img src="../../../public/huarong.png" alt="" />
        </div>
        <div>
          <span>{{$t("case.haoen.module")}}：WMS、MES、QMS、IoT、SaaS</span>
          <div>1.WMS：{{$t("case.huarong.wms")}}</div>
          <div>
            2.MES：{{$t("case.huarong.mes")}}
          </div>
          <div>3.QMS：{{$t("case.huarong.qms")}}</div>
          <div>
            4.IoT：{{$t("case.huarong.iot")}}
          </div>
          <div>5.{{$t("case.huarong.huawei")}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.suteng {
  margin: 0px 150px;
  padding-top: 100px;
}
.title {
  font-size: 18px;
  color: #121212;
  line-height: 24px;
  padding-bottom: 40px;
  border-bottom: 1px solid #dfdfdf;
}
.title > span {
  font-size: 14px;
  color: #7e7e7c;
}
.business {
  font-size: 14px;
  color: #7e7e7c;
  line-height: 30px;
}

.business > h4 {
  margin: 30px 0;
  font-size: 16px;
  font-weight: 800;
  color: #121212;
}
.box {
  margin-bottom: 40px;
}
.content {
  display: flex;
  align-items: center;
  margin-bottom: 80px;
}
.content-img {
  margin-left: 0;
  margin-right: 4%;
}
.business > .content img {
  width: 700px;
  height: 400px;
  margin-right: 80px;
}
</style>
